import React from "react";
import {AcademicCapIcon, HomeIcon, ChatIcon} from "@heroicons/react/solid";
import SyndicationIcon from "../components/widgets/icons/SyndicationIcon";
import Logout from "../pages/Logout";
import AppSettingsIcon from "../components/widgets/icons/AppSettingsIcon";
import SettingsIcon from "../components/widgets/icons/SettingsIcon";
import TrainingIcon from "../components/widgets/icons/TrainingIcon";
import TrainingRegistrationForm from "../features/trainingPortal/TrainingRegistrationForm";
import TrainingHome from "../features/trainingPortal/TrainingHome";
import RegisteredListingIcon from "../components/widgets/icons/RegisteredListingIcon";
import AppSettings from "../features/appSettings/AppSettings";
import RegisteredListings from "../features/registeredListing/RegisteredListings";
import RegisteredListing from "../features/registeredListing/RegisteredListing";
import Profile from "../pages/Profile";
import Home from "../pages/Home";
import GeneralSettings from "../features/generalSettings/GeneralSettings";
import NewsArticle from "../features/news/Article";
import NewsArticles from "../features/news/Articles";
import Notifications from "../features/notification/Notifications";
import SystemNotifications from "../features/systemNotification/SystemNotifications";
import AorMessages from "../features/systemNotification/AorMessages";
import AorMessage from "../features/systemNotification/AorMessage";

export type routeObject = {
    id?: string,
    title?: string,
    path?: string,
    exact?: boolean,
    component?: React.FC | null,
    icon?: React.FunctionComponent<any>,
    // icon: ElementType,
    target?: '_blank' | null,
    menu?: 'user' | 'main' | 'none',
    color?: string,
    viewOrder?: number | 0,
}

/*
 * This is TEMP Routes since eventually these will come from a DB call
 */
export const tempRoutes: routeObject[] = [
    {
        path: '/',
        exact: true,
        component: Home,
        icon: HomeIcon,
    },
    {
        path: '/settings',
        exact: true,
        component: GeneralSettings,
        icon: SettingsIcon,
    },
    {
        path: '/settings/:urlTab?',
        exact: true,
        component: GeneralSettings,
        icon: SettingsIcon,
    },
    {
        path: '/product_settings',
        exact: true,
        component: AppSettings,
        icon: AppSettingsIcon,
    },
    {
        path: '/registered',
        exact: true,
        component: RegisteredListings,
        icon: RegisteredListingIcon,
    },
    {
        path: '/registered/:id',
        exact: true,
        component: RegisteredListing,
        icon: RegisteredListingIcon,
    },
    {
        path: '/training',
        exact: true,
        component: TrainingHome,
        icon: TrainingIcon,
    },
    {
        path: '/training/:urlTab?',
        exact: true,
        component: TrainingHome,
        icon: TrainingIcon,
    },
    {
        path: '/training/registration/:eventId',
        exact: true,
        component: TrainingRegistrationForm,
        icon: TrainingIcon,
    },
    {
        path: 'https://choice.crmls.org/synd',
        exact: true,
        component: null,
        icon: SyndicationIcon,
    },
    {
        path: '/aor-messages',
        exact: true,
        component: AorMessages,
        icon: ChatIcon,
    },
    {
        path: '/aor-messages/:messageId',
        exact: true,
        component: AorMessage,
        icon: ChatIcon,
    },
    {
        path: '/profile',
        exact: true,
        component: Profile,
        icon: SettingsIcon,
    },
    {
        path: '/logout',
        exact: true,
        component: Logout,
        icon: SettingsIcon,
    },
    {
        path: '/articles/',
        exact: true,
        component: NewsArticles,
        icon: AcademicCapIcon,
    },
    {
        path: '/article/:articleId',
        exact: true,
        component: NewsArticle,
        icon: AcademicCapIcon,
    },
    {
        path: '/notifications',
        exact: true,
        component: Notifications,
        icon: AcademicCapIcon,
    },
    {
        path: '/system-notifications',
        exact: true,
        component: SystemNotifications,
        icon: AcademicCapIcon,
    },
]
